'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, useMemo } from 'react';
import SimpleChart, { type SimpleChartProps } from '@/components/charts/components/SimpleChart';
import { isSerieEmpty } from '@/components/charts/helpers/highcharts';
import { useHighchartsOptions } from '@/components/charts/hooks/useHighchartsOptions';
import { PositionHistoryPlaceholder } from '@/components/common/PositionHistoryPlaceholder';
import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider';
export interface MyDepositsChartContentProps {
  statuses: SimpleChartProps['statuses'];
  data?: [number, number | null][];
  variant?: 'default' | 'small';
  className?: string;
}
const chartConfig: Record<'default' | 'small', Partial<SimpleChartProps>> = {
  default: {
    borderRadius: 8,
    hideXAxis: false,
    hideYAxis: false
  },
  small: {
    borderRadius: 8,
    hideBorder: true,
    hideXAxis: true,
    hideYAxis: true,
    margins: [1, 1, 1, 1]
  }
};
const MyDepositsChartContent = t0 => {
  const $ = _c(22);
  const {
    data,
    statuses,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const {
    positionHistory: isPositionHistoryEnabled
  } = useFeatureFlags();
  const {
    palette
  } = useHighchartsOptions();
  const {
    borderRadius,
    hideXAxis,
    margins,
    hideBorder,
    hideYAxis
  } = chartConfig[variant];
  let t2;
  if ($[0] !== data) {
    t2 = data ?? [];
    $[0] = data;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = isSerieEmpty(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const hasData = !t3;
  if (!isPositionHistoryEnabled) {
    let t4;
    if ($[4] !== variant) {
      t4 = <PositionHistoryPlaceholder height="inherit" variant={variant} />;
      $[4] = variant;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t4;
  if ($[6] !== data || $[7] !== hasData || $[8] !== palette) {
    t4 = hasData ? [{
      type: "areaspline",
      name: "Your Deposits",
      data,
      color: palette.colors[0],
      lineColor: palette.colors[0],
      fillColor: palette.areaChartColors[0]
    }] : [];
    $[6] = data;
    $[7] = hasData;
    $[8] = palette;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = data?.[0]?.[1] || undefined;
  let t6;
  if ($[10] !== t5) {
    t6 = [{
      value: t5,
      className: "hc-plotline-border",
      color: "var(--border)",
      dashStyle: "Dash",
      width: 1
    }];
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== borderRadius || $[13] !== className || $[14] !== hideBorder || $[15] !== hideXAxis || $[16] !== hideYAxis || $[17] !== margins || $[18] !== statuses || $[19] !== t4 || $[20] !== t6) {
    t7 = <SimpleChart className={className} statuses={statuses} unit="$" hideXAxis={hideXAxis} hideYAxis={hideYAxis} borderRadius={borderRadius} margins={margins} hideBorder={hideBorder} noAnimation={true} series={t4} plotlinesY={t6} height="inherit" flexGrow={1} />;
    $[12] = borderRadius;
    $[13] = className;
    $[14] = hideBorder;
    $[15] = hideXAxis;
    $[16] = hideYAxis;
    $[17] = margins;
    $[18] = statuses;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default memo(MyDepositsChartContent);